import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Interaction = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="m12.233 4.755 1.057-.812A6.667 6.667 0 0 0 1.333 8h1.334a5.333 5.333 0 0 1 9.566-3.245Zm1.644 6.395-1.174-.631A5.31 5.31 0 0 0 13.333 8c0-.758-.158-1.493-.46-2.17l1.219-.542A6.65 6.65 0 0 1 14.667 8a6.64 6.64 0 0 1-.79 3.15ZM1.52 9.572l1.296-.313c.105.433.264.85.472 1.242l-1.177.627a6.623 6.623 0 0 1-.591-1.556Zm1.762 3.138.943-.942a5.37 5.37 0 0 0 1.83 1.2l-.487 1.241a6.674 6.674 0 0 1-2.286-1.499Zm4.035.58-.17 1.323a6.65 6.65 0 0 0 5.813-2.16l-.99-.89a5.317 5.317 0 0 1-4.653 1.727ZM9.333 8a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM5.333 8a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Interaction;
